import useApiRequest from 'api/useApiRequest';
import { fetchCrmEmails, type CrmEmailListItem } from 'api/services/crmEmailService';

const useCrmEmails = () => {
  const { request } = useApiRequest();

  const getDraftEmails = async ({ signal }: { signal?: AbortSignal } = {}): Promise<CrmEmailListItem[]> => {
    const { data } = await fetchCrmEmails(request, { signal });
    return (data?.results ?? []).filter((email: CrmEmailListItem) => email.status === 'Draft');
  };

  return { getDraftEmails };
};

export default useCrmEmails;
